export default __webpack_public_path__ + "static/td_synnex_logo-631a2029d12ff8bd6e3fdfc8830cee5c.png";